import React from "react";
import { withTranslation } from "react-i18next";
import { FlexRow, ButtonData } from "./Tabs.styled";

const Tabs = (props) => {
  const { t, activeTab, toggleTab, type } = props;

  return (
    <FlexRow>
      {type === "general" && (
        <>
          <div>
            <ButtonData
              marginRight="10px"
              color={activeTab === "enquiry" ? "#008395" : "#cccccc"}
              onClick={() => toggleTab("enquiry")}
            >
              {t("GENERAL_INFORMATION")}
            </ButtonData>
          </div>

          <div>
            <ButtonData
              marginRight="10px"
              color={activeTab === "contact" ? "#008395" : "#cccccc"}
              onClick={() => toggleTab("contact")}
            >
              {t("CONTACT_INFORMATION")}
            </ButtonData>
          </div>

          <div>
            <ButtonData
              marginRight="10px"
              color={activeTab === "document" ? "#008395" : "#cccccc"}
              onClick={() => toggleTab("document")}
            >
              {t("DOCUMENTS")}
            </ButtonData>
          </div>
        </>
      )}
      {type === "price" && (
        <>
          <div>
            <ButtonData
              marginRight="10px"
              color={activeTab === "solution" ? "#008395" : "#cccccc"}
              onClick={() => toggleTab("solution")}
            >
              {t("ENQUIRIES_SOLUTIONS")}
            </ButtonData>
          </div>

          <div>
            <ButtonData
              marginRight="10px"
              color={activeTab === "sellingPrice" ? "#008395" : "#cccccc"}
              onClick={() => toggleTab("sellingPrice")}
            >
              {t("ENQUIRIES_SELLING_PRICES")}
            </ButtonData>
          </div>
        </>
      )}
    </FlexRow>
  );
};

export default withTranslation()(Tabs);
